import { render, staticRenderFns } from "./CargoComdtyHelpList.vue?vue&type=template&id=5c881dcf&"
import script from "./CargoComdtyHelpList.vue?vue&type=script&lang=js&"
export * from "./CargoComdtyHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports